import { useQuery } from '@tanstack/react-query';
import { getOrders, getOrdersCount } from 'utils/UnifiedViewWebAPIUtils';

export const useOrderData = (params, options) => {
  return useQuery({
    queryKey: ['orders', params, options],
    queryFn: () => getOrders(params, options),
    keepPreviousData: true,
    staleTime: 10000,
    cacheTime: 10 * 60 * 1000, // 10 minutes
    enabled: !!params && Object.keys(params).length > 0,
  });
};

export const useOrderDataCount = (params) => {
  return useQuery({
    queryKey: ['ordersCount', params],
    queryFn: () => getOrdersCount({ params }),
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    enabled: !!params && Object.keys(params).length > 0,
  });
};
